module.exports = __webpack_public_path__ + "static/media/watermark.55ae7c19.png";